import { authedClient } from '@/api/trpc';
import useAuth from './useAuth';

const useRefreshToken = () => {
  const auth = useAuth();

  const refresh = async () => {
    const data = await authedClient.auth.refreshToken.query();
    const userData = data?.user;
    const accessToken = data?.id;
    auth?.setUser((prev: any) => {
      return {
        ...prev,
        ...data,
        user: userData,
        accessToken,
      }
    });
    return data.id;
  }
  return refresh;
};

export default useRefreshToken;
